import { LikeButtonVariants } from '@atoms/LikeButton/LikeButton';
import Text from '@atoms/Text/Text';
import CardTypeEnum from '@models/enums/CardTypeEnum';
import { IAddToWishlistProps } from '@models/IAddToWishlist';
import { IShareButton } from '@models/IShareButton';
import { IWishlistDrawerLabels } from '@models/IWishlistDrawer';
import ShareButton from '@molecules/ShareButton/ShareButton';
import { ComponentType } from 'react';

export interface IArticleStamp {
  readonly id: string;
  readonly date: string;
  readonly timeStamp: string;
  readonly showPublishedDate: boolean;
  readonly shareButton: IShareButton;
  readonly wishlistDrawerLabels: IWishlistDrawerLabels;
  readonly WishlistButton?: ComponentType<IAddToWishlistProps>;
}

const ArticleStamp = ({
  id,
  date,
  timeStamp,
  shareButton,
  showPublishedDate,
  wishlistDrawerLabels,
  WishlistButton,
}: IArticleStamp) => (
  <section className="tw-my-[60px] tw-flex tw-w-full tw-border-b tw-border-grey-20 tw-pb-4 md:tw-my-20">
    <div className="tw-flex  tw-gap-6 tw-py-[5px] tw-text-grey-70">
      {showPublishedDate && date && (
        <Text dir="ltr" variant="body-small" className="tw-uppercase">
          {date}
        </Text>
      )}
      {timeStamp && showPublishedDate && date && (
        <span className="tw-h-4 tw-w-[1px] tw-bg-grey-20" />
      )}
      <Text variant="body-small">{timeStamp}</Text>
    </div>
    <div className="tw-ml-auto tw-flex tw-gap-4 rtl:tw-ml-0 rtl:tw-mr-auto">
      {WishlistButton && (
        <WishlistButton
          cardId={id}
          isCard={false}
          collection={CardTypeEnum.Colours}
          wishlistDrawerLabels={wishlistDrawerLabels}
          buttonVariant={LikeButtonVariants.Bordered}
        />
      )}
      <ShareButton {...shareButton} />
    </div>
  </section>
);

export default ArticleStamp;
